// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import GetTextPlugin from 'vue-gettext'
import { Tooltip } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueNativeSock from 'vue-native-websocket'

import App from './App'
import router from './router'

import Config from '../../shared/src/mixins/Config.js'
import Logger from '../../shared/src/mixins/Logger.js'
import WindowVars from '../../shared/src/mixins/WindowVars'
import { fullSocketUrl } from '../../shared/src/utils/vueAwsSocket'
import Strings from '../../shared/src/mixins/Strings'

import translationOptions from '../../shared/src/utils/translationOptions.js'

Vue.config.productionTip = false
Vue.use(GetTextPlugin, translationOptions)

// Load up ws manual connection for later test
Vue.use(VueNativeSock, fullSocketUrl('1111', 'troubleshooter', null, null, 'troubleshooter'), {connectManually: true})

Vue.component(Tooltip.name, Tooltip)

Vue.mixin(Config)
Vue.mixin(Logger)
Vue.mixin(Strings)

if (process.env.VUE_APP_LC_ENV === 'local' || process.env.VUE_APP_LC_ENV === 'dev') {
  Vue.mixin(WindowVars)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App},
  render: h => h('app')
})

// import * as Sentry from '@sentry/browser'
//
// Sentry.init({
//   dsn: 'https://4ae3fb0e3e99474e9a46511cdc3d204c@sentry.io/1314550',
//   integrations: [new Sentry.Integrations.Vue({ Vue })]
// })
